import React from 'react';
import PropTypes from 'prop-types';
import { cn } from '../../utils/lib/utils';

const List = React.forwardRef(({ className, children, ...props }, ref) => {
  return (
    <ul
      ref={ref}
      className={cn(
        'list-none p-0 m-0 space-y-2',
        className
      )}
      {...props}
    >
      {children}
    </ul>
  );
});

List.displayName = 'List';

List.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node
};

const ListItem = React.forwardRef(({ className, children, ...props }, ref) => {
  return (
    <li
      ref={ref}
      className={cn(
        'flex items-start p-4 border rounded-lg bg-background hover:bg-muted/50 transition-colors',
        className
      )}
      {...props}
    >
      {children}
    </li>
  );
});

ListItem.displayName = 'ListItem';

ListItem.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node
};

export { List, ListItem }; 